module.exports = __webpack_public_path__ + "videos/optimised/eb409d10ad0a0c2860b5561f5bb9467a.mp4";